import { AnimatePresence, motion } from 'framer-motion';
import { NAV_ITEMS } from '../../constants';

export const Navigation = ({ scrolled, menuOpen, setMenuOpen, onNavigate, activeSection }) => (
  <>
    <nav className={`pf-nav${scrolled ? ' scrolled' : ''}`}>
      <div className="pf-nav-inner">
        <button className="pf-logo" onClick={() => onNavigate('hero')} aria-label="Jam Ardines, back to top">
          jam<span className="pf-logo-dot">.</span>
        </button>
        <ul className="pf-nav-links">
          {NAV_ITEMS.map(([id, label]) => (
            <li key={id}>
              <button
                onClick={() => onNavigate(id)}
                className={`${activeSection === id ? 'active' : ''}${id === 'contact' ? ' pf-nav-contact' : ''}`}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
        <button
          className={`pf-hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen((p) => !p)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>

    <AnimatePresence>
      {menuOpen && (
        <motion.div
          className="pf-mobile-menu"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {NAV_ITEMS.map(([id, label]) => (
            <button key={id} onClick={() => onNavigate(id)}>{label}</button>
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  </>
);
